module.exports = __webpack_public_path__ + "img/CM-AE-25-Subaru-Modern.ac3f4a21.jpg";